import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    'quantity_type',
    'exam_method', 'exam_method_input', 'exam_method_output',
    'application_type_text', 'application_type_text_output',
    'application_type_exam', 'application_type_exam_output',
    'add_text_application', 'del_text_application',
    'add_exam_application', 'del_exam_application',
    'name_of_text', 'number_of_text', 'unit_price_of_text', 'unit_of_text', 'total_of_text', 'sum_of_text', 'image_of_text',
    'name_of_exam', 'number_of_exam', 'unit_price_of_exam', 'unit_of_exam', 'total_of_exam', 'sum_of_exam', 'mark_of_exam', 'role_of_exam', 'pass_number_input', 'pass_number_label',
  ]

  connect() {
    this.quantity_typeTargets.forEach(m => m.addEventListener('change', e => this.func_quantity_type(e)))
    this.exam_methodTarget.addEventListener('change', e => this.func_exam_method(e.target.checked))

    this.application_type_textTarget.addEventListener('change', e => this.func_application_type_text(e.target.checked))
    this.add_text_applicationTarget.addEventListener('click', e => this.func_add_text_application(e))
    this.del_text_applicationTargets.forEach((_m, i) => this.func_append_text(i))

    this.application_type_examTarget.addEventListener('change', e => this.func_application_type_exam(e.target.checked))
    this.add_exam_applicationTarget.addEventListener('click', e => this.func_add_exam_application(e))
    this.del_exam_applicationTargets.forEach((_m, i) => this.func_append_exam(i))

    this.func_application_type_text(this.application_type_textTarget.checked)
    this.func_application_type_exam(this.application_type_examTarget.checked)
    this.func_quantity_type()
  }

  func_quantity_type_single_checked() {
    let checked = false
    this.quantity_typeTargets.forEach(m => { if (m.checked && m.value == 'single') checked = true })
    return checked
  }

  func_quantity_type() {
    const single_checked = this.func_quantity_type_single_checked()

    if (single_checked) {
      this.number_of_examTargets.forEach(m => { m.readOnly = true; m.value = 1 })
      this.del_exam_applicationTargets.forEach((m, i) => { if (i > 0) m.click() })
      this.func_calc_exam()
    } else {
      this.number_of_examTargets.forEach(m => m.readOnly = false)
    }

    this.exam_method_inputTarget.hidden = single_checked

    if (single_checked) {
      this.exam_methodTarget.checked ? this.exam_methodTarget.click() : this.func_exam_method(false)
    } else {
      this.func_exam_method(this.exam_methodTarget.checked)
    }

    this.add_exam_applicationTarget.hidden = single_checked && this.del_exam_applicationTargets.length > 0
  }

  func_exam_method(checked) {
    this.exam_method_outputTargets.forEach(m => m.hidden = !checked)
    this.func_calc_exam()
  }

  func_application_type_text(checked) {
    this.application_type_text_outputTarget.hidden = !checked

    if (checked) {
      if (this.del_text_applicationTargets.length == 0) this.add_text_applicationTarget.click()
    } else {
      this.del_text_applicationTargets.forEach(m => m.click())
    }
  }

  func_add_text_application() {
    const self = this
    setTimeout(function() {
      self.func_append_text(self.del_text_applicationTargets.length - 1)
      self.func_calc_text()
    }, 20)
  }

  func_append_text(i) {
    this.del_text_applicationTargets[i].addEventListener('click', e => this.func_del_text_application(e))
    this.name_of_textTargets[i].addEventListener('change', e => this.func_calc_text(e))
    const num = this.number_of_textTargets[i]
    num.addEventListener('input', e => this.func_calc_text(e))
  }

  func_del_text_application() {
    const self = this
    setTimeout(function() {
      self.func_calc_text()
    }, 20)
  }

  func_calc_text() {
    let sum = 0
    this.name_of_textTargets.forEach((m, i) => {
      let unit = this.unit_price_of_textTargets[m.options.selectedIndex].dataset.value
      const num = this.number_of_textTargets[i].value - 0
      if (num >= 30) unit = Math.floor(unit * 0.9)
      this.image_of_textTargets[i].innerHTML = this.unit_price_of_textTargets[m.options.selectedIndex].innerHTML
      this.unit_of_textTargets[i].textContent = `単価 : ${new Intl.NumberFormat().format(unit)}円`
      this.total_of_textTargets[i].textContent = `小計 : ${new Intl.NumberFormat().format(unit * num)}円`
      sum += unit * num
    })
    this.sum_of_textTarget.textContent = `テキスト合計金額 : ${new Intl.NumberFormat().format(sum)}円`
  }

  func_application_type_exam(checked) {
    this.application_type_exam_outputTarget.hidden = !checked

    if (checked) {
      if (this.del_exam_applicationTargets.length == 0) {
        this.add_exam_applicationTarget.click()
        this.add_exam_applicationTarget.hidden = this.func_quantity_type_single_checked()
      }
    } else {
      this.del_exam_applicationTargets.forEach(m => m.click())
      this.exam_methodTarget.checked ? this.exam_methodTarget.click() : this.func_exam_method(false)
    }
  }

  func_add_exam_application() {
    const self = this
    setTimeout(function() {
      self.func_append_exam(self.del_exam_applicationTargets.length - 1)
      self.func_calc_exam()
    }, 20)
  }

  func_append_exam(i) {
    this.del_exam_applicationTargets[i].addEventListener('click', e => this.func_del_exam_application(e))
    this.name_of_examTargets[i].addEventListener('change', e => this.func_calc_exam(e))
    const num = this.number_of_examTargets[i]
    num.addEventListener('input', e => this.func_calc_exam(e))
    num.readOnly = this.func_quantity_type_single_checked()
  }

  func_del_exam_application() {
    const self = this
    setTimeout(function() {
      self.func_calc_exam()
    }, 20)
  }

  func_calc_exam() {
    let sum = 0
    let mark = 0
    this.name_of_examTargets.forEach((m, i) => {
      const exam = this.unit_price_of_examTargets[m.options.selectedIndex].dataset
      const required_name = exam.requiredName || ''
      let unit = exam.value
      const num = this.number_of_examTargets[i].value - 0
      const role = this.role_of_examTarget.dataset.value
      this.pass_number_inputTargets[i].style.display = this.func_quantity_type_single_checked() && !!required_name ? 'block' : 'none'
      this.pass_number_labelTargets[i].textContent = `${required_name}合格番号`
      if (role == 'supporting_member') unit = Math.floor(unit * 0.8)
      if (role == 'school') unit = Math.floor(unit * 0.7)
      if (this.exam_methodTarget.checked) mark += this.mark_of_examTarget.dataset.unitPrice * num
      this.unit_of_examTargets[i].textContent = `単価 : ${new Intl.NumberFormat().format(unit)}円`
      this.total_of_examTargets[i].textContent = `小計 : ${new Intl.NumberFormat().format(unit * num)}円`
      sum += unit * num
    })
    this.mark_of_examTarget.textContent = `マークシート料金 : ${new Intl.NumberFormat().format(mark)}円`
    this.sum_of_examTarget.textContent = `検定合計金額 : ${new Intl.NumberFormat().format(sum + mark)}円`
  }
}
